import { Injectable } from '@angular/core';
import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class LearnersService {
  private routes = ApiRoutes.api;
  constructor(
    private readonly httpService: HttpService,
    private readonly http: HttpClient
  ) { }

  addLearner(payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.learner.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  allLearners(pagination?: { page?: number; limit?: number }, filters?: {
    classroom?: number;
    academic_level?: number;
    series?: number;
    semester?: number;
    course?: number;
    teacher?: number;
  }) {
    const params: any = {};

    if (pagination) {
      if (pagination.page) params.page = pagination.page;
      if (pagination.limit) params.limit = pagination.limit;
    }

    if (filters) {
      if (filters.classroom) params.classroom = filters.classroom;
      if (filters.academic_level) params.academic_level = filters.academic_level;
      if (filters.series) params.series = filters.series;
      if (filters.semester) params.semester = filters.semester;
      if (filters.course) params.course = filters.course;
      if (filters.teacher) params.teacher = filters.teacher;
    }

    return this.httpService.makeRequest({
      path: this.routes.learner.retrieve,
      method: 'get',
      options: { params },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  registerLearners(id: number, payload: { learnerIds: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.classroom.registerLearners,
      method: 'post',
      options: { id, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getLearnerRegisteredCourses(learnerId: number, semester?: number, academicLevel?: number) {
    return this.httpService.makeRequest({
      path: this.routes.learner.getRegisteredCourses,
      method: 'get',
      options: { id: learnerId, params: { semester, academicLevel } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getLearner(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.learner.retrieveSingle,
      method: 'get',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getLearnerByMatricule(matricule: string) {
    return this.httpService.makeRequest({
      path: this.routes.learner.findByMatricule,
      method: 'get',
      options: { id: matricule },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getLearnerResults(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.result.downloadReportCard,
      method: 'get',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  downloadReportCard(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.transcript.download,
      method: 'get',
      options: { id, responseType: 'blob' },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  downloadResultSheet(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.result.downloadReportCard,
      method: 'get',
      options: { id, responseType: 'blob' },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  downloadPromotionReport(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.result.downloadPromotionReport,
      method: 'get',
      options: { id, responseType: 'blob' },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  downloadAllClassReportCards(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.result.downloadClassReportCards,
      method: 'get',
      options: {
        id,
        responseType: 'arraybuffer',
        headers: { 'Accept': 'application/pdf' }
      },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  editLearner(id: number, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.learner.edit,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  deleteLearner(id: string) {
    return this.httpService.makeRequest({
      path: this.routes.learner.delete,
      method: 'delete',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  bulkDelete(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.learner.bulkDelete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  generateTranscript(id: number, academic_year_id: number) {
    return this.httpService.makeRequest({
      path: this.routes.transcript.download,
      method: 'post',
      options: {
        body: {
          learnerId: id,
          academicYearId: academic_year_id
        }, responseType: 'blob'
      },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  generateIdCard(id: number) {
    return this.httpService.makeRequest({
      path: this.routes.idCard.generateLearner,
      method: 'post',
      options: { id, responseType: 'blob' },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getLearnersBySpecialization(specializationId: number) {
    return this.httpService.makeRequest({
      path: this.routes.learner.retrieve,
      method: 'get',
      options: { params: { specialization: specializationId } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getLearnersBySeries(seriesId: number) {
    return this.httpService.makeRequest({
      path: this.routes.learner.retrieve,
      method: 'get',
      options: { params: { series: seriesId } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getLearnersByDepartment(departmentId: number) {
    return this.httpService.makeRequest({
      path: this.routes.learner.retrieve,
      method: 'get',
      options: { params: { department: departmentId } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  transferLearnerClass(payload: {
    learner_id: number;
    target_classroom_id?: number;
    target_series_id?: number;
    effective_semester_id: number;
    reason?: string;
  }) {
    return this.httpService.makeRequest({
      path: this.routes.learner.transferClass,
      method: 'post',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getLearnerClassTransferHistory(learnerId: number) {
    return this.httpService.makeRequest({
      path: this.routes.learner.classTransferHistory,
      method: 'get',
      options: { id: learnerId },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getLearnerAcademicHistory(learnerId: number) {
    return this.httpService.makeRequest({
      path: this.routes.learner.academicHistory,
      method: 'get',
      options: { id: learnerId },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }
}
